export const general_tab = 'general';
export const archive_tab = 'archive';
export const entries_tab = 'entries';
export const building_equipments_tab = 'building-equipments';
export const pdfs_tab = 'pdfs';
export const repair_tasks_tab = 'repair-tasks';
export const meta_data_tab = 'meta-data';
export const notes_tab = 'notes';
